import { request } from '../../utils/index'

// TODO (noahlaux): This file is subject to become multiple exports
// eslint-disable-next-line import/prefer-default-export
export const fetchTimeZones = () => {
  return request({
    url: '/api/utility/timezones',
    method: 'GET',
  })
}
